// extracted by mini-css-extract-plugin
module.exports = {"container":"tg","error":"ug","disabled":"vg","option":"wg","submit":"xg","success":"yg","failure":"zg"};